import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, of, tap, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalConstants } from '../common/global';
import { GdprApiResponse, GdprQuestion } from '../components/gdpr-modal/gdpr-modal.models';

@Injectable({
  providedIn: 'root'
})
export class GdprService {
  private gdprQuestions: GdprQuestion[] | null = null;
  readonly gdprTextId = signal<number | null>(null);

  constructor(private http: HttpClient, private formBuilder: FormBuilder) {}

  getGdprQuestions(): Observable<FormGroup> {
    const url = `${environment.apiUrl}/v1/main/user/gdpr?connId=${environment.connId}`;

    if (this.gdprQuestions) {
      return of(this.createFormGroup(this.gdprQuestions));
    } else {
      return this.http.get<GdprApiResponse>(url, {headers: GlobalConstants.headers.headers})
        .pipe(
          tap((response) => {
            this.gdprQuestions = response.data.gdprQuestions.gdprQuestionItems;
            this.gdprTextId.set(response.data.gdprText.gdprTextId);
          }),
          map(() => this.createFormGroup(this.gdprQuestions!))
        );
    }
  }

  private createFormGroup(questions: GdprQuestion[]): FormGroup {
    const questionsFormArray = this.formBuilder.array(
      questions.map(question => this.createQuestionGroup(question))
    );

    return this.formBuilder.group({
      questions: questionsFormArray
    });
  }

  private createQuestionGroup(question: GdprQuestion): FormGroup {
    return this.formBuilder.group({
      questionId: [question.questionId],
      answer: [false, question.required ? Validators.requiredTrue : null],
      questionMessage: [question.questionText],
      questionRequired: [question.required]
    });
  }
}
